(ns bp-clients.tv-app.nav.views.paywall
  "Namespace for login page view for when user is logged-out"
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.nav.events :as nav-events]
   [bp-clients.tv-app.utils.qrcode :refer [generate-qr-code]]
   [bp-libs.design-system.components.buttons :refer [Button]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn paywall
  [{:keys [qr_code_url message background_image]}]
  (let [main-focus-ref (createRef)]
    (r/create-class
     {:component-did-mount (fn [_react-component]
                             (when-let [main-button main-focus-ref.current]
                               (.focus main-button)))
      :reagent-render (fn [_props]
                        [:main {:class "flex min-h-screen w-full bg-black text-white overflow-hidden overscroll-contain"}
                         [:div {:class "w-full h-full absolute z-0"}
                          [:img {:src background_image
                                 :class ["w-full h-full"]}]]
                         [:div {:class ["w-full flex flex-col"
                                        "items-center justify-center space-y-10"
                                        "z-10"
                                        "opacity-90"]
                                :style {:background "radial-gradient(#000000, #134E48)"}}
                          [:h1 {:class "text-5xl font-bold"}
                           "Desbloqueie conteúdos"]
                          [:p {:class "w-[40rem] text-center font-medium text-3xl"}
                           message]
                          (when (seq qr_code_url)
                            [:div {:class ["qr-code"]
                                   :dangerouslySetInnerHTML {:__html (generate-qr-code qr_code_url 5 0)}}])
                          [:div {:class "flex space-x-4 text-sm"}
                           [Button {:color         "black"
                                    :extra-classes ["px-4 outline-none"]
                                    :react-ref     main-focus-ref
                                    :tab-index     10
                                    :on-click      #(rf/dispatch [::nav-events/close-paywall])}
                            "Entendi"]]]])})))
